import React from "react";
import "./styles.scss";

const FinanceEmissions = () => {
    return (
        <div className="finance-emissions-main">
            <iframe
                src="/finance-emissions.html"
                title="Financed Emissions & Climate Risk"
                className="finance-emissions-frame"
            />
        </div>
    );
};

export default FinanceEmissions;
